export default __webpack_public_path__ + "static/media/FelixNwatu.6ecb6e34.svg";